import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { CreateAlertSuccess } from '@app/+product/store/actions/product.action';
import { OTHER_BRAND } from './utils';

/**
 * On product pages, when user creates a global alert for a specific product.
 */
const events = getEvents((action: CreateAlertSuccess) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'globalAlert',
      product_brand: action.payload.brand.id === OTHER_BRAND.id ? OTHER_BRAND.name : action.payload.brand.name,
      product_category: action.payload.category.name,
      product_univers: action.payload.universe.name
    }
  },
  {
    type: 'Create an alert - productPage',
    container: TagContainer.Media
  }
]);

export default events;
